import React from 'react';

interface BlueprintIconProps {
  className?: string;
}

const BlueprintIcon: React.FC<BlueprintIconProps> = ({ className = "h-4 w-4" }) => {
  return (
    <svg 
      className={className}
      viewBox="0 0 48 48" 
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M36,17.25H16.75V16c0-1.5166-1.2334-2.75-2.75-2.75h-1c-2.06738,0-3.75,1.68213-3.75,3.75v18.5
          c0,1.79199,1.45801,3.25,3.25,3.25H36c1.5166,0,2.75-1.2334,2.75-2.75V20C38.75,18.4834,37.5166,17.25,36,17.25z M10.75,17
          c0-1.24072,1.00977-2.25,2.25-2.25h1c0.68945,0,1.25,0.56055,1.25,1.25v15c0,0.68945-0.56055,1.25-1.25,1.25h-1.5
          c-0.63867,0-1.24121,0.1958-1.75,0.52881V17z M37.25,36c0,0.68945-0.56055,1.25-1.25,1.25H12.5c-0.96484,0-1.75-0.78516-1.75-1.75
          c0-0.94873,0.80176-1.75,1.75-1.75H14c1.5166,0,2.75-1.2334,2.75-2.75V18.75H36c0.68945,0,1.25,0.56055,1.25,1.25V36z"/>
        <path d="M33.51129,21.43103c-0.08704,0.07458-13.99957,11.99963-13.99957,11.99963
          c-0.51788,0.4436-0.19598,1.31934,0.48846,1.31934c0.05792,0,13.99982,0,13.99982,0c0.41406,0,0.75-0.33594,0.75-0.75V22
          C34.75,21.37585,33.99036,21.02039,33.51129,21.43103z M33.25,33.25H22.02734L33.25,23.63086V33.25z"/>
        <path d="M29,31.75c0.00775,0,2,0,2,0c0.41406,0,0.75-0.33594,0.75-0.75v-2c0-1.00916-1.5-0.89246-1.5,0c0,0.00214,0,1.25,0,1.25H29
          C28.01965,30.25,28.07391,31.75,29,31.75z"/>
        <path d="M18.66504,12.6709c0,0,4,2,4.02032,2.00482C22.78369,14.72203,22.89092,14.75,23,14.75h13c1.5166,0,2.75-1.2334,2.75-2.75
          S37.5166,9.25,36,9.25c0,0-13,0-13.00001,0c-0.11666,0-0.22864,0.03362-0.33495,0.0791c0,0-3.99275,1.99638-3.99999,2
          C18.12477,11.59923,18.12501,12.40192,18.66504,12.6709z M23.75,10.75h9.5v2.5h-9.5V10.75z M37.25,12
          c0,0.68945-0.56055,1.25-1.25,1.25h-1.25v-2.5H36C36.68945,10.75,37.25,11.31055,37.25,12z M22.25,11.21338v1.57324L20.67676,12
          L22.25,11.21338z"/>
        <path d="M19.25,27.00006c0,0.01342,0,1.99193,0,1.99993c0,0.89253,1.5,0.92696,1.5-0.00005c0-0.00818,0-1.99994,0-1.99994
          C20.75,26.03827,19.25,26.06854,19.25,27.00006z"/>
        <path d="M25,22.75c0.00775,0,2,0,2,0c0.98041,0,0.92755-1.5,0-1.5c-0.00812,0-2,0-2,0C24.0144,21.25,24.06982,22.75,25,22.75z"/>
        <path d="M21.99994,21.25c-0.01093,0-1.99994,0-1.99994,0c-0.41406,0-0.75,0.33594-0.75,0.75c0,0,0,1.99262,0,1.99998
          c0,0.89613,1.5,0.92423,1.5-0.00005c0-0.00671,0-1.24994,0-1.24994H22C22.96405,22.75,22.92682,21.25,21.99994,21.25z"/>
      </g>
    </svg>
  );
};

export default BlueprintIcon;
